module.exports = __webpack_public_path__ + "img/tg.13271ef0.jpg";